// // import "./update.scss";
// // import Sidebar from "../../components/sidebar/Sidebar";
// // import Navbar from "../../components/navbar/Navbar";
// // import Select from "react-select";
// // import DriveFolderUploadOutlinedIcon from "@mui/icons-material/DriveFolderUploadOutlined";
// // import { useLocation, useNavigate } from "react-router-dom";
// // import { useState, useEffect } from "react";
// // import { teacher_attendanceInputs } from "../../formSource";
// // import { serverUrl } from "../../temp";
// // import { ToastContainer, toast } from "react-toastify";
// // import "react-toastify/dist/ReactToastify.css";

// // const statusOptions = [
// //   { value: 1, label: "Active" },
// //   { value: 0, label: "Inactive" },
// // ];
// // const TSOptions = [
// //   { value: "Present", label: "Present" },
// //   { value: "Absent", label: "Absent" },
// //   { value: "Late", label: "Late" },
// //   { value: "Replacement", label: "Replacement" },
// // ];

// // const TeacherAttendanceUpdate = ({ title }) => {
// //   const location = useLocation();
// //   const navigate = useNavigate();
// //   const [inputValues, setInputValues] = useState({});
// //   const [selectedStatus, setSelectedStatus] = useState(null);
// //   const [selectedDay, setSelectedDay] = useState(null);
// //   const [selectedUser, setSelectedUser] = useState([]);
// //   const [useroptions, setUseroptions] = useState([]);
// //   const [selectedSubject, setSelectedSubject] = useState([]);
// //   const [selectedUser_rep, setSelectedUser_rep] = useState([]);
// //   const [selectedSubject_rep, setSelectedSubject_rep] = useState([]);
// //   const [teacher_status, setTeacher_status] = useState([]);
// //   const [Subjectoptions, setSubjectoptions] = useState([]);
// //   const [selectedClass, setSelectedClass] = useState([]);
// //   const [selectedtt_id, setSelectedtt_id] = useState([]);
// //   const [Classoptions, setClassoptions] = useState([]);
// //   const center_id = localStorage.getItem("center_id");
// //   const teacher_attendanceId = location.pathname.match(
// //     /\/update-teacher-attendance\/(\d+)/
// //   )?.[1];

// //   let [token] = useState(localStorage.getItem("token"));

// //   const redirectToLogin = () => {
// //     alert("Please Login first then you can access this page...");
// //     window.location.href = "/";
// //   };

// //   useEffect(() => {
// //     const fetchTeacher_attendance = async () => {
// //       try {
// //         const response = await fetch(
// //           `${serverUrl}/teacher_attendance/${teacher_attendanceId}`,
// //           {
// //             method: "GET",
// //           }
// //         );
// //         if (!response.ok) {
// //           throw new Error("Failed to fetch teacher attendance");
// //         }
// //         const data = await response.json();

// //         // Set teacher info
// //         const teacherName = data.data.teacher_name;
// //         const teacherId = data.data.teacher_id;
// //         setSelectedUser([{ value: teacherId, label: teacherName }]);

// //         // Set subject info
// //         const subjectName = data.data.subject_name;
// //         const subjectId = data.data.subject_id;
// //         setSelectedSubject([{ value: subjectId, label: subjectName }]);

// //         // Set class info
// //         const className = data.data.class_name;
// //         const classId = data.data.class_id;
// //         setSelectedClass([{ value: classId, label: className }]);

// //         // Set replacement info if exists
// //         if (data.data.user_rep_id && data.data.user_rep_id !== "None") {
// //           const userRepName = data.data.user_rep_name;
// //           const userRepId = data.data.user_rep_id;
// //           setSelectedUser_rep([{ value: userRepId, label: userRepName }]);
// //         }

// //         if (data.data.subject_rep_id && data.data.subject_rep_id !== "None") {
// //           const subjectRepName = data.data.subject_rep_name;
// //           const subjectRepId = data.data.subject_rep_id;
// //           setSelectedSubject_rep([
// //             { value: subjectRepId, label: subjectRepName },
// //           ]);
// //         }

// //         setInputValues(data.data);
// //         setSelectedtt_id(data.data.id);

// //         // Set status dropdown
// //         if (data.data.status == 1) {
// //           setSelectedStatus({ value: data.data.status, label: "Active" });
// //         } else {
// //           setSelectedStatus({ value: data.data.status, label: "Inactive" });
// //         }

// //         // Set day dropdown
// //         const dayOptions = {
// //           Monday: "Monday",
// //           Tuesday: "Tuesday",
// //           Wednesday: "Wednesday",
// //           Thursday: "Thursday",
// //           Friday: "Friday",
// //           Saturday: "Saturday",
// //           Sunday: "Sunday",
// //         };
// //         setSelectedDay({
// //           value: data.data.day,
// //           label: dayOptions[data.data.day],
// //         });

// //         // Set teacher status
// //         const statusOptions = {
// //           Present: "Present",
// //           Absent: "Absent",
// //           Late: "Late",
// //           Replacement: "Replacement",
// //         };
// //         setTeacher_status({
// //           value: data.data.teacher_status,
// //           label: statusOptions[data.data.teacher_status],
// //         });
// //       } catch (error) {
// //         console.error(error);
// //         toast.error("Failed to load teacher attendance data");
// //       }
// //     };

// //     if (teacher_attendanceId) {
// //       fetchTeacher_attendance();
// //     }
// //   }, [teacher_attendanceId]);

// //   // Fetch dropdown options
// //   useEffect(() => {
// //     const fetchOptions = async () => {
// //       try {
// //         // Fetch users
// //         const usersResponse = await fetch(`${serverUrl}/user_ids/${center_id}`);
// //         const usersData = await usersResponse.json();
// //         setUseroptions(
// //           usersData.data.map((user) => ({
// //             value: user.id,
// //             label: user.name,
// //           }))
// //         );

// //         // Fetch classes
// //         const classesResponse = await fetch(
// //           `${serverUrl}/class_ids/${center_id}`
// //         );
// //         const classesData = await classesResponse.json();
// //         setClassoptions(
// //           classesData.data.map((cls) => ({
// //             value: cls.id,
// //             label: cls.name,
// //           }))
// //         );

// //         // Fetch subjects
// //         const subjectsResponse = await fetch(
// //           `${serverUrl}/subject_ids/${center_id}`
// //         );
// //         const subjectsData = await subjectsResponse.json();
// //         setSubjectoptions(
// //           subjectsData.data.map((subj) => ({
// //             value: subj.id,
// //             label: subj.name,
// //           }))
// //         );
// //       } catch (error) {
// //         console.error("Error fetching options:", error);
// //       }
// //     };

// //     fetchOptions();
// //   }, [center_id]);

// //   const handleTeacher_StatusSelectChange = (selectedOption) => {
// //     setTeacher_status(selectedOption);
// //     setInputValues({
// //       ...inputValues,
// //       teacher_status: selectedOption.value,
// //     });
// //   };

// //   const handleUserSelectChange = (selectedOption) => {
// //     setSelectedUser_rep(selectedOption);
// //     setInputValues({
// //       ...inputValues,
// //       user_rep_id: selectedOption.value,
// //     });
// //   };

// //   const handleSubjectSelectChange = (selectedOption) => {
// //     setSelectedSubject_rep(selectedOption);
// //     setInputValues({
// //       ...inputValues,
// //       subject_rep_id: selectedOption.value,
// //     });
// //   };

// //   const handleSubmit = async (e) => {
// //     e.preventDefault();

// //     try {
// //       const formData = new FormData();
// //       formData.append("center_id", localStorage.getItem("center_id"));
// //       formData.append("timetable_id", inputValues.timetable_id || 1);
// //       formData.append("teacher_attendance_id", selectedtt_id);
// //       formData.append("teacher_status", teacher_status.value);
// //       formData.append("date", inputValues.date);
// //       formData.append("subject_rep_id", inputValues.subject_rep_id || "None");
// //       formData.append("user_rep_id", inputValues.user_rep_id || "None");
// //       formData.append("status", inputValues.status || 1);

// //       fetch(`${serverUrl}/upd_teacher_attendance/${teacher_attendanceId}`, {
// //         method: "PUT",
// //         body: formData,
// //       })
// //         .then((response) => {
// //           return response.json();
// //         })
// //         .then((data) => {
// //           if (data.code >= 400) {
// //             if (typeof data.message === "object") {
// //               Object.entries(data.message).forEach(([field, errors]) => {
// //                 errors.forEach((errMsg) => {
// //                   toast.error(`${field}: ${errMsg}`);
// //                 });
// //               });
// //             } else {
// //               toast.error(data.message || "Something went wrong.");
// //             }

// //             // Force the component to rerender with the empty state
// //             setTimeout(() => {}, 500);
// //           } else {
// //             toast.success("Teacher attendance updated successfully!");
// //             setTimeout(() => {
// //               navigate("/teacher-attendance");
// //             }, 1000);
// //           }
// //         })
// //         .catch((error) => {
// //           console.log(error);
// //           toast.error("Failed to update teacher attendance");
// //         });
// //     } catch (error) {
// //       console.log(error);
// //       toast.error("An error occurred while preparing the request");
// //     }
// //   };

// //   return (
// //     <>
// //       {!token && redirectToLogin()}
// //       {token && (
// //         <div className="new">
// //           <Sidebar />
// //           <div className="newContainer">
// //             <Navbar />
// //             <div className="top">
// //               <h1>{title}</h1>
// //             </div>
// //             <div className="bottom">
// //               <div className="right">
// //                 <form onSubmit={handleSubmit}>
// //                   {teacher_attendanceInputs.map((input) => (
// //                     <div className="formInput" key={input.id}>
// //                       {input.fieldName === "status" ? null : (
// //                         <>
// //                           <label>{input.label}</label>
// //                           {input.fieldName === "teacher_status" ? (
// //                             <Select
// //                               options={TSOptions}
// //                               value={teacher_status}
// //                               onChange={handleTeacher_StatusSelectChange}
// //                               required
// //                             />
// //                           ) : input.fieldName === "subject_rep_id" ? (
// //                             (teacher_status.value === "Replacement" ||
// //                               teacher_status.value === "Absent") && (
// //                               <Select
// //                                 options={Subjectoptions}
// //                                 value={selectedSubject_rep}
// //                                 onChange={handleSubjectSelectChange}
// //                                 required
// //                               />
// //                             )
// //                           ) : input.fieldName === "user_rep_id" ? (
// //                             (teacher_status.value === "Replacement" ||
// //                               teacher_status.value === "Absent") && (
// //                               <Select
// //                                 options={useroptions}
// //                                 value={selectedUser_rep}
// //                                 onChange={handleUserSelectChange}
// //                                 required
// //                               />
// //                             )
// //                           ) : input.fieldName === "subject_id" ? (
// //                             <input
// //                               type="text"
// //                               value={
// //                                 selectedSubject.length > 0
// //                                   ? selectedSubject[0].label
// //                                   : ""
// //                               }
// //                               readOnly
// //                               className="read-only-input"
// //                             />
// //                           ) : input.fieldName === "user_id" ? (
// //                             <input
// //                               type="text"
// //                               value={
// //                                 selectedUser.length > 0
// //                                   ? selectedUser[0].label
// //                                   : ""
// //                               }
// //                               readOnly
// //                               className="read-only-input"
// //                             />
// //                           ) : input.fieldName === "class_id" ? (
// //                             <input
// //                               type="text"
// //                               value={
// //                                 selectedClass.length > 0
// //                                   ? selectedClass[0].label
// //                                   : ""
// //                               }
// //                               readOnly
// //                               className="read-only-input"
// //                             />
// //                           ) : input.fieldName === "day" ? (
// //                             <input
// //                               type="text"
// //                               value={selectedDay ? selectedDay.label : ""}
// //                               readOnly
// //                               className="read-only-input"
// //                             />
// //                           ) : (
// //                             <input
// //                               type={input.type}
// //                               placeholder={input.placeholder}
// //                               name={input.fieldName}
// //                               value={inputValues[input.fieldName] || ""}
// //                               onChange={(e) => {
// //                                 setInputValues({
// //                                   ...inputValues,
// //                                   [e.target.name]: e.target.value,
// //                                 });
// //                               }}
// //                               required={input.fieldName !== "status"}
// //                             />
// //                           )}
// //                         </>
// //                       )}
// //                     </div>
// //                   ))}
// //                   <div style={{ clear: "both" }} className="formSubmit">
// //                     <button type="submit" style={{ float: "right" }}>
// //                       Update
// //                     </button>
// //                   </div>
// //                 </form>
// //               </div>
// //             </div>
// //           </div>
// //         </div>
// //       )}
// //       <ToastContainer position="top-right" autoClose={3000} />
// //     </>
// //   );
// // };

// // export default TeacherAttendanceUpdate;
// import React, { useState, useEffect } from "react";
// import Select from "react-select";
// import Sidebar from "../../components/sidebar/Sidebar";
// import Navbar from "../../components/navbar/Navbar";
// import { teacher_attendanceInputs } from "../../formSource";
// import { useLocation, useNavigate } from "react-router-dom";
// import { serverUrl } from "../../temp";
// import { toast, ToastContainer } from "react-toastify";
// import "react-toastify/dist/ReactToastify.css";
// import Button from "@mui/material/Button";
// import Box from "@mui/material/Box";
// import { createTheme, ThemeProvider } from "@mui/material/styles";
// import Card from "@mui/material/Card";
// import CardContent from "@mui/material/CardContent";
// import Typography from "@mui/material/Typography";
// import Grid from "@mui/material/Grid";
// import "./update.scss";

// const theme = createTheme({
//   palette: {
//     primary: {
//       main: "#7451f8",
//     },
//     secondary: {
//       main: "#6c757d",
//     },
//   },
// });

// const statusOptions = [
//   { value: 1, label: "Active" },
//   { value: 0, label: "Inactive" },
// ];

// const TSOptions = [
//   { value: "Present", label: "Present" },
//   { value: "Absent", label: "Absent" },
//   { value: "Late", label: "Late" },
//   { value: "Replacement", label: "Replacement" },
// ];

// const TeacherAttendanceUpdate = ({ title }) => {
//   const location = useLocation();
//   const navigate = useNavigate();
//   const [inputValues, setInputValues] = useState({});
//   const [selectedStatus, setSelectedStatus] = useState(null);
//   const [selectedDay, setSelectedDay] = useState(null);
//   const [selectedUser, setSelectedUser] = useState([]);
//   const [useroptions, setUseroptions] = useState([]);
//   const [selectedSubject, setSelectedSubject] = useState([]);
//   const [selectedUser_rep, setSelectedUser_rep] = useState([]);
//   const [selectedSubject_rep, setSelectedSubject_rep] = useState([]);
//   const [teacher_status, setTeacher_status] = useState(null);
//   const [Subjectoptions, setSubjectoptions] = useState([]);
//   const [selectedClass, setSelectedClass] = useState([]);
//   const [selectedtt_id, setSelectedtt_id] = useState([]);
//   const [Classoptions, setClassoptions] = useState([]);
//   const center_id = localStorage.getItem("center_id");
//   const teacher_attendanceId = location.pathname.match(/\/update-teacher-attendance\/(\d+)/)?.[1];
//   let [token] = useState(localStorage.getItem("token"));

//   const redirectToLogin = () => {
//     alert("Please Login first, then you can access this page...");
//     window.location.href = "/";
//   };

//   useEffect(() => {
//     const fetchTeacher_attendance = async () => {
//       try {
//         const response = await fetch(
//           `${serverUrl}/teacher_attendance/${teacher_attendanceId}`,
//           {
//             method: "GET",
//           }
//         );
//         if (!response.ok) {
//           throw new Error("Failed to fetch teacher attendance data");
//         }
//         const data = await response.json();

//         // Set teacher info
//         setSelectedUser([{
//           value: data.data.teacher_id,
//           label: data.data.teacher_name
//         }]);

//         // Set subject info
//         setSelectedSubject([{
//           value: data.data.subject_id,
//           label: data.data.subject_name
//         }]);

//         // Set class info
//         setSelectedClass([{
//           value: data.data.class_id,
//           label: data.data.class_name
//         }]);

//         // Set replacement info if exists
//         if (data.data.user_rep_id && data.data.user_rep_id !== "None") {
//           setSelectedUser_rep([{
//             value: data.data.user_rep_id,
//             label: data.data.user_rep_name
//           }]);
//         }

//         if (data.data.subject_rep_id && data.data.subject_rep_id !== "None") {
//           setSelectedSubject_rep([{
//             value: data.data.subject_rep_id,
//             label: data.data.subject_rep_name
//           }]);
//         }

//         setInputValues(data.data);
//         setSelectedtt_id(data.data.id);

//         // Set status dropdown
//         setSelectedStatus(
//           data.data.status === 1
//             ? { value: 1, label: "Active" }
//             : { value: 0, label: "Inactive" }
//         );

//         // Set day dropdown
//         setSelectedDay({
//           value: data.data.day,
//           label: data.data.day
//         });

//         // Set teacher status
//         setTeacher_status(
//           TSOptions.find(option => option.value === data.data.teacher_status) || null
//         );
//       } catch (error) {
//         console.error(error);
//         toast.error("Failed to fetch teacher attendance data");
//       }
//     };

//     if (teacher_attendanceId) {
//       fetchTeacher_attendance();
//     }
//   }, [teacher_attendanceId]);

//   useEffect(() => {
//     const fetchOptions = async () => {
//       try {
//         // Fetch users
//         const usersResponse = await fetch(`${serverUrl}/user_ids/${center_id}`);
//         const usersData = await usersResponse.json();
//         setUseroptions(
//           usersData.data.map(user => ({
//             value: user.id,
//             label: user.name
//           }))
//         );

//         // Fetch classes
//         const classesResponse = await fetch(`${serverUrl}/class_ids/${center_id}`);
//         const classesData = await classesResponse.json();
//         setClassoptions(
//           classesData.data.map(cls => ({
//             value: cls.id,
//             label: cls.name
//           }))
//         );

//         // Fetch subjects
//         const subjectsResponse = await fetch(`${serverUrl}/subject_ids/${center_id}`);
//         const subjectsData = await subjectsResponse.json();
//         setSubjectoptions(
//           subjectsData.data.map(subj => ({
//             value: subj.id,
//             label: subj.name
//           }))
//         );
//       } catch (error) {
//         console.error("Error fetching options:", error);
//         toast.error("Failed to fetch dropdown options");
//       }
//     };

//     fetchOptions();
//   }, [center_id]);

//   const handleTeacher_StatusSelectChange = (selectedOption) => {
//     setTeacher_status(selectedOption);
//     setInputValues({
//       ...inputValues,
//       teacher_status: selectedOption.value,
//     });
//   };

//   const handleUserSelectChange = (selectedOption) => {
//     setSelectedUser_rep(selectedOption);
//     setInputValues({
//       ...inputValues,
//       user_rep_id: selectedOption.value,
//     });
//   };

//   const handleSubjectSelectChange = (selectedOption) => {
//     setSelectedSubject_rep(selectedOption);
//     setInputValues({
//       ...inputValues,
//       subject_rep_id: selectedOption.value,
//     });
//   };

//   const handleInputChange = (e) => {
//     setInputValues({
//       ...inputValues,
//       [e.target.name]: e.target.value,
//     });
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();

//     try {
//       const formData = new FormData();
//       formData.append("center_id", center_id);
//       formData.append("timetable_id", inputValues.timetable_id || 1);
//       formData.append("teacher_attendance_id", selectedtt_id);
//       formData.append("teacher_status", teacher_status.value);
//       formData.append("date", inputValues.date);
//       formData.append("subject_rep_id", inputValues.subject_rep_id || "None");
//       formData.append("user_rep_id", inputValues.user_rep_id || "None");
//       formData.append("status", inputValues.status || 1);

//       const response = await fetch(
//         `${serverUrl}/upd_teacher_attendance/${teacher_attendanceId}`,
//         {
//           method: "PUT",
//           body: formData,
//         }
//       );

//       const data = await response.json();
//       if (data.code >= 400) {
//         if (typeof data.message === "object") {
//           Object.entries(data.message).forEach(([field, errors]) => {
//             errors.forEach((errMsg) => {
//               toast.error(`${field}: ${errMsg}`);
//             });
//           });
//         } else {
//           toast.error(data.message || "Something went wrong.");
//         }
//       } else {
//         toast.success("Teacher attendance updated successfully!");
//         setTimeout(() => {
//           navigate("/teacher-attendance");
//         }, 1000);
//       }
//     } catch (error) {
//       console.error(error);
//       toast.error("Failed to update teacher attendance");
//     }
//   };

//   return (
//     <ThemeProvider theme={theme}>
//       {!token && redirectToLogin()}
//       {token && (
//         <div className="update">
//           <Sidebar />
//           <div className="updateContainer">
//             <Navbar />
//             <div className="contentWrapper">
//               <Card className="formCard">
//                 <CardContent className="cardContent">
//                   <Typography variant="h5" component="h2" gutterBottom className="formTitle">
//                     {title}
//                   </Typography>
//                   <form onSubmit={handleSubmit} className="responsiveForm">
//                     <Grid container spacing={2}>
//                       {teacher_attendanceInputs.map((input) => (
//                         input.fieldName !== "status" && (
//                           <Grid item xs={12} sm={6} key={input.id} className="formGridItem">
//                             <div className="formInput">
//                               <label>{input.label}</label>
//                               {input.fieldName === "teacher_status" ? (
//                                 <Select
//                                   options={TSOptions}
//                                   value={teacher_status}
//                                   onChange={handleTeacher_StatusSelectChange}
//                                   required
//                                   className="selectInput"
//                                   styles={{
//                                     control: (base) => ({
//                                       ...base,
//                                       minHeight: '46px',
//                                       borderColor: '#e2e8f0',
//                                       '&:hover': {
//                                         borderColor: '#cbd5e0'
//                                       }
//                                     }),
//                                     valueContainer: (base) => ({
//                                       ...base,
//                                       padding: '2px 8px'
//                                     }),
//                                     input: (base) => ({
//                                       ...base,
//                                       margin: '0',
//                                       padding: '0'
//                                     }),
//                                     indicatorsContainer: (base) => ({
//                                       ...base,
//                                       height: '44px'
//                                     })
//                                   }}
//                                 />
//                               ) : input.fieldName === "subject_rep_id" ? (
//                                 (teacher_status?.value === "Replacement" || teacher_status?.value === "Absent") && (
//                                   <Select
//                                     options={Subjectoptions}
//                                     value={selectedSubject_rep}
//                                     onChange={handleSubjectSelectChange}
//                                     required
//                                     className="selectInput"
//                                     styles={{
//                                       control: (base) => ({
//                                         ...base,
//                                         minHeight: '46px',
//                                         borderColor: '#e2e8f0',
//                                         '&:hover': {
//                                           borderColor: '#cbd5e0'
//                                         }
//                                       }),
//                                       valueContainer: (base) => ({
//                                         ...base,
//                                         padding: '2px 8px'
//                                       }),
//                                       input: (base) => ({
//                                         ...base,
//                                         margin: '0',
//                                         padding: '0'
//                                       }),
//                                       indicatorsContainer: (base) => ({
//                                         ...base,
//                                         height: '44px'
//                                       })
//                                     }}
//                                   />
//                                 )
//                               ) : input.fieldName === "user_rep_id" ? (
//                                 (teacher_status?.value === "Replacement" || teacher_status?.value === "Absent") && (
//                                   <Select
//                                     options={useroptions}
//                                     value={selectedUser_rep}
//                                     onChange={handleUserSelectChange}
//                                     required
//                                     className="selectInput"
//                                     styles={{
//                                       control: (base) => ({
//                                         ...base,
//                                         minHeight: '46px',
//                                         borderColor: '#e2e8f0',
//                                         '&:hover': {
//                                           borderColor: '#cbd5e0'
//                                         }
//                                       }),
//                                       valueContainer: (base) => ({
//                                         ...base,
//                                         padding: '2px 8px'
//                                       }),
//                                       input: (base) => ({
//                                         ...base,
//                                         margin: '0',
//                                         padding: '0'
//                                       }),
//                                       indicatorsContainer: (base) => ({
//                                         ...base,
//                                         height: '44px'
//                                       })
//                                     }}
//                                   />
//                                 )
//                               ) : input.fieldName === "subject_id" ? (
//                                 <input
//                                   type="text"
//                                   value={selectedSubject[0]?.label || ""}
//                                   readOnly
//                                   className="read-only-input"
//                                 />
//                               ) : input.fieldName === "user_id" ? (
//                                 <input
//                                   type="text"
//                                   value={selectedUser[0]?.label || ""}
//                                   readOnly
//                                   className="read-only-input"
//                                 />
//                               ) : input.fieldName === "class_id" ? (
//                                 <input
//                                   type="text"
//                                   value={selectedClass[0]?.label || ""}
//                                   readOnly
//                                   className="read-only-input"
//                                 />
//                               ) : input.fieldName === "day" ? (
//                                 <input
//                                   type="text"
//                                   value={selectedDay?.label || ""}
//                                   readOnly
//                                   className="read-only-input"
//                                 />
//                               ) : (
//                                 <input
//                                   type={input.type}
//                                   placeholder={input.placeholder}
//                                   name={input.fieldName}
//                                   value={inputValues[input.fieldName] || ""}
//                                   onChange={handleInputChange}
//                                   required={input.fieldName !== "status"}
//                                 />
//                               )}
//                             </div>
//                           </Grid>
//                         )
//                       ))}
//                     </Grid>
//                     <Box sx={{ display: "flex", justifyContent: "center", gap: 3, mt: 4, pb: 2 }}>
//                       <Button
//                         variant="outlined"
//                         color="secondary"
//                         onClick={() => navigate("/teacher-attendance")}
//                         sx={{ minWidth: '120px', height: '42px' }}
//                       >
//                         Cancel
//                       </Button>
//                       <Button
//                         type="submit"
//                         variant="contained"
//                         color="primary"
//                         sx={{ minWidth: '150px', height: '42px' }}
//                       >
//                         Update Attendance
//                       </Button>
//                     </Box>
//                   </form>
//                 </CardContent>
//               </Card>
//             </div>
//           </div>
//         </div>
//       )}
//       <ToastContainer position="top-right" autoClose={3000} />
//     </ThemeProvider>
//   );
// };

// export default TeacherAttendanceUpdate;

import React, { useState, useEffect } from "react";
import Select from "react-select";
import Sidebar from "../../components/sidebar/Sidebar";
import Navbar from "../../components/navbar/Navbar";
import { teacher_attendanceInputs } from "../../formSource";
import { useLocation, useNavigate } from "react-router-dom";
import { serverUrl } from "../../temp";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Button from "@mui/material/Button";
import Box from "@mui/material/Box";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Typography from "@mui/material/Typography";
import Grid from "@mui/material/Grid";
import "./update.scss";

const theme = createTheme({
  palette: {
    primary: {
      main: "#7451f8",
    },
    secondary: {
      main: "#6c757d",
    },
  },
});

const statusOptions = [
  { value: 1, label: "Active" },
  { value: 0, label: "Inactive" },
];

const TSOptions = [
  { value: "Present", label: "Present" },
  { value: "Absent", label: "Absent" },
  { value: "Late", label: "Late" },
  { value: "Replacement", label: "Replacement" },
];

const TeacherAttendanceUpdate = ({ title }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const [inputValues, setInputValues] = useState({});
  const [selectedStatus, setSelectedStatus] = useState(null);
  const [selectedDay, setSelectedDay] = useState(null);
  const [selectedUser, setSelectedUser] = useState([]);
  const [useroptions, setUseroptions] = useState([]);
  const [selectedSubject, setSelectedSubject] = useState([]);
  const [selectedUser_rep, setSelectedUser_rep] = useState([]);
  const [selectedSubject_rep, setSelectedSubject_rep] = useState([]);
  const [teacher_status, setTeacher_status] = useState(null);
  const [Subjectoptions, setSubjectoptions] = useState([]);
  const [selectedClass, setSelectedClass] = useState([]);
  const [selectedtt_id, setSelectedtt_id] = useState([]);
  const [Classoptions, setClassoptions] = useState([]);
  const center_id = localStorage.getItem("center_id");
  const teacher_attendanceId = location.pathname.match(/\/update-teacher-attendance\/(\d+)/)?.[1];
  let [token] = useState(localStorage.getItem("token"));

  const redirectToLogin = () => {
    alert("Please Login first, then you can access this page...");
    window.location.href = "/";
  };

  useEffect(() => {
    const fetchTeacher_attendance = async () => {
      try {
        const response = await fetch(
          `${serverUrl}/teacher_attendance/${teacher_attendanceId}`,
          {
            method: "GET",
          }
        );
        if (!response.ok) {
          throw new Error("Failed to fetch teacher attendance data");
        }
        const data = await response.json();

        // Set teacher info
        setSelectedUser([{
          value: data.data.teacher_id,
          label: data.data.teacher_name
        }]);

        // Set subject info
        setSelectedSubject([{
          value: data.data.subject_id,
          label: data.data.subject_name
        }]);

        // Set class info
        setSelectedClass([{
          value: data.data.class_id,
          label: data.data.class_name
        }]);

        // Set replacement info if exists
        if (data.data.user_rep_id && data.data.user_rep_id !== "None") {
          setSelectedUser_rep([{
            value: data.data.user_rep_id,
            label: data.data.user_rep_name
          }]);
        }

        if (data.data.subject_rep_id && data.data.subject_rep_id !== "None") {
          setSelectedSubject_rep([{
            value: data.data.subject_rep_id,
            label: data.data.subject_rep_name
          }]);
        }

        setInputValues(data.data);
        setSelectedtt_id(data.data.id);

        // Set status dropdown
        setSelectedStatus(
          data.data.status === 1
            ? { value: 1, label: "Active" }
            : { value: 0, label: "Inactive" }
        );

        // Set day dropdown
        setSelectedDay({
          value: data.data.day,
          label: data.data.day
        });

        // Set teacher status
        setTeacher_status(
          TSOptions.find(option => option.value === data.data.teacher_status) || null
        );
      } catch (error) {
        console.error(error);
        toast.error("Failed to fetch teacher attendance data");
      }
    };

    if (teacher_attendanceId) {
      fetchTeacher_attendance();
    }
  }, [teacher_attendanceId]);

  useEffect(() => {
    const fetchOptions = async () => {
      try {
        // Fetch users
        const usersResponse = await fetch(`${serverUrl}/user_ids/${center_id}`);
        const usersData = await usersResponse.json();
        setUseroptions(
          usersData.data.map(user => ({
            value: user.id,
            label: user.name
          }))
        );

        // Fetch classes
        const classesResponse = await fetch(`${serverUrl}/class_ids/${center_id}`);
        const classesData = await classesResponse.json();
        setClassoptions(
          classesData.data.map(cls => ({
            value: cls.id,
            label: cls.name
          }))
        );

        // Fetch subjects
        const subjectsResponse = await fetch(`${serverUrl}/subject_ids/${center_id}`);
        const subjectsData = await subjectsResponse.json();
        setSubjectoptions(
          subjectsData.data.map(subj => ({
            value: subj.id,
            label: subj.name
          }))
        );
      } catch (error) {
        console.error("Error fetching options:", error);
        toast.error("Failed to fetch dropdown options");
      }
    };

    fetchOptions();
  }, [center_id]);

  const handleTeacher_StatusSelectChange = (selectedOption) => {
    setTeacher_status(selectedOption);
    setInputValues({
      ...inputValues,
      teacher_status: selectedOption.value,
    });
  };

  const handleUserSelectChange = (selectedOption) => {
    setSelectedUser_rep(selectedOption);
    setInputValues({
      ...inputValues,
      user_rep_id: selectedOption.value,
    });
  };

  const handleSubjectSelectChange = (selectedOption) => {
    setSelectedSubject_rep(selectedOption);
    setInputValues({
      ...inputValues,
      subject_rep_id: selectedOption.value,
    });
  };

  const handleInputChange = (e) => {
    setInputValues({
      ...inputValues,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const formData = new FormData();
      formData.append("center_id", center_id);
      formData.append("timetable_id", inputValues.timetable_id || 1);
      formData.append("teacher_attendance_id", selectedtt_id);
      formData.append("teacher_status", teacher_status.value);
      formData.append("date", inputValues.date);
      formData.append("subject_rep_id", inputValues.subject_rep_id || "None");
      formData.append("user_rep_id", inputValues.user_rep_id || "None");
      formData.append("status", inputValues.status || 1);

      const response = await fetch(
        `${serverUrl}/upd_teacher_attendance/${teacher_attendanceId}`,
        {
          method: "PUT",
          body: formData,
        }
      );

      const data = await response.json();
      if (data.code >= 400) {
        if (typeof data.message === "object") {
          Object.entries(data.message).forEach(([field, errors]) => {
            errors.forEach((errMsg) => {
              toast.error(`${field}: ${errMsg}`);
            });
          });
        } else {
          toast.error(data.message || "Something went wrong.");
        }
      } else {
        toast.success("Teacher attendance updated successfully!");
        setTimeout(() => {
          navigate("/teacher-attendance");
        }, 1000);
      }
    } catch (error) {
      console.error(error);
      toast.error("Failed to update teacher attendance");
    }
  };

  return (
    <ThemeProvider theme={theme}>
      {!token && redirectToLogin()}
      {token && (
        <div className="update">
          <Sidebar />
          <div className="updateContainer">
            <Navbar />
            <div className="contentWrapper">
              <Card className="formCard">
                <CardContent className="cardContent">
                  <Typography variant="h5" component="h2" gutterBottom className="formTitle">
                    {title}
                  </Typography>
                  <form onSubmit={handleSubmit} className="responsiveForm">
                    <Grid container spacing={2}>
                      {teacher_attendanceInputs.map((input) => (
                        input.fieldName !== "status" && (
                          <Grid item xs={12} sm={6} key={input.id} className="formGridItem">
                            <div className="formInput">
                              <label>{input.label}</label>
                              {input.fieldName === "teacher_status" ? (
                                <Select
                                  options={TSOptions}
                                  value={teacher_status}
                                  onChange={handleTeacher_StatusSelectChange}
                                  required
                                  className="selectInput"
                                  styles={{
                                    control: (base) => ({
                                      ...base,
                                      minHeight: '46px',
                                      borderColor: '#e2e8f0',
                                      '&:hover': {
                                        borderColor: '#cbd5e0'
                                      }
                                    }),
                                    valueContainer: (base) => ({
                                      ...base,
                                      padding: '2px 8px'
                                    }),
                                    input: (base) => ({
                                      ...base,
                                      margin: '0',
                                      padding: '0'
                                    }),
                                    indicatorsContainer: (base) => ({
                                      ...base,
                                      height: '44px'
                                    })
                                  }}
                                />
                              ) : input.fieldName === "subject_rep_id" ? (
                                (teacher_status?.value === "Replacement" || teacher_status?.value === "Absent") && (
                                  <Select
                                    options={Subjectoptions}
                                    value={selectedSubject_rep}
                                    onChange={handleSubjectSelectChange}
                                    required
                                    className="selectInput"
                                    styles={{
                                      control: (base) => ({
                                        ...base,
                                        minHeight: '46px',
                                        borderColor: '#e2e8f0',
                                        '&:hover': {
                                          borderColor: '#cbd5e0'
                                        }
                                      }),
                                      valueContainer: (base) => ({
                                        ...base,
                                        padding: '2px 8px'
                                      }),
                                      input: (base) => ({
                                        ...base,
                                        margin: '0',
                                        padding: '0'
                                      }),
                                      indicatorsContainer: (base) => ({
                                        ...base,
                                        height: '44px'
                                      })
                                    }}
                                  />
                                )
                              ) : input.fieldName === "user_rep_id" ? (
                                (teacher_status?.value === "Replacement" || teacher_status?.value === "Absent") && (
                                  <Select
                                    options={useroptions}
                                    value={selectedUser_rep}
                                    onChange={handleUserSelectChange}
                                    required
                                    className="selectInput"
                                    styles={{
                                      control: (base) => ({
                                        ...base,
                                        minHeight: '46px',
                                        borderColor: '#e2e8f0',
                                        '&:hover': {
                                          borderColor: '#cbd5e0'
                                        }
                                      }),
                                      valueContainer: (base) => ({
                                        ...base,
                                        padding: '2px 8px'
                                      }),
                                      input: (base) => ({
                                        ...base,
                                        margin: '0',
                                        padding: '0'
                                      }),
                                      indicatorsContainer: (base) => ({
                                        ...base,
                                        height: '44px'
                                      })
                                    }}
                                  />
                                )
                              ) : input.fieldName === "subject_id" ? (
                                <input
                                  type="text"
                                  value={selectedSubject[0]?.label || ""}
                                  readOnly
                                  className="read-only-input"
                                />
                              ) : input.fieldName === "user_id" ? (
                                <input
                                  type="text"
                                  value={selectedUser[0]?.label || ""}
                                  readOnly
                                  className="read-only-input"
                                />
                              ) : input.fieldName === "class_id" ? (
                                <input
                                  type="text"
                                  value={selectedClass[0]?.label || ""}
                                  readOnly
                                  className="read-only-input"
                                />
                              ) : input.fieldName === "day" ? (
                                <input
                                  type="text"
                                  value={selectedDay?.label || ""}
                                  readOnly
                                  className="read-only-input"
                                />
                              ) : (
                                <input
                                  type={input.type}
                                  placeholder={input.placeholder}
                                  name={input.fieldName}
                                  value={inputValues[input.fieldName] || ""}
                                  onChange={handleInputChange}
                                  required={input.fieldName !== "status"}
                                />
                              )}
                            </div>
                          </Grid>
                        )
                      ))}
                    </Grid>
                    <Box sx={{ display: "flex", justifyContent: "center", gap: 3, mt: 4, pb: 2 }}>
                      <Button
                        variant="outlined"
                        color="secondary"
                        onClick={() => navigate("/teacher-attendance")}
                        sx={{ minWidth: '120px', height: '42px' }}
                      >
                        Cancel
                      </Button>
                      <Button
                        type="submit"
                        variant="contained"
                        color="primary"
                        sx={{ minWidth: '150px', height: '42px' }}
                      >
                        Update Attendance
                      </Button>
                    </Box>
                  </form>
                </CardContent>
              </Card>
            </div>
          </div>
        </div>
      )}
      <ToastContainer position="top-right" autoClose={3000} />
    </ThemeProvider>
  );
};

export default TeacherAttendanceUpdate;